// The domain default state, and nothing else.
//
// Progress persistence moved to progress/local.ts when accounts arrived: it is
// per-user, versioned at 6, and holds a snapshot plus an un-pushed event tail.
// What is left here is not a persistence concern and has ten importers.
//
// The pre-accounts `aybuben:v1` key is gone. It held the v5 progress that
// The one-shot adoption would have read, merged, and cleared — but nothing
// ever called that adoption, so no build ever read or wrote the key, and
// reading it could only have done harm: a cache is a cache miss when this
// build cannot read it, and the refusal to discard remotely is sync/engine.ts's.

import { detectLang } from "./lang.ts";
import type { GameState } from "./state.ts";

// A factory, not a shared constant: `stats`, `done` and `unlocked` are nested
// objects, so handing out `{ ...DEFAULT_STATE }` would alias them into every
// caller. One in-place mutation anywhere would then poison the defaults for the
// rest of the session — a reset that stops resetting.
// The first lowercase unit — content/course/units.json's "u.alpha.1" — is
// unlocked from a fresh install. Hardcoded rather than imported from the
// course module: storage.ts is a persistence adapter and stays decoupled
// from content.
const FIRST_UNIT = "u.alpha.1";

export function defaultState(): GameState {
	return {
		stats: {},
		done: {},
		unlocked: { [FIRST_UNIT]: true },
		slips: {},
		// storage.ts stays decoupled from content; lang.ts is app vocabulary, not
		// course data, and imports nothing from content/.
		lang: detectLang(globalThis.navigator?.language),
		onboarded: 0,
		layout: "phonetic",
		kbdHinted: false,
		treeName: "",
	};
}

export const DEFAULT_STATE: GameState = defaultState();
